module.exports = __webpack_public_path__ + "static/media/card_list_skeleton_2.5b2c782c.svg";